"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.changeLanguage = exports.languageLocalStorageKey = void 0;
var i18next_1 = __importDefault(require("i18next"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var react_i18next_1 = require("react-i18next");
var en_json_1 = __importDefault(require("./en.json"));
exports.languageLocalStorageKey = 'i18nextLng_dapp';
function initialize(options) {
    var translationsJson = {
        en: {
            translation: (0, lodash_merge_1["default"])(en_json_1["default"], (options === null || options === void 0 ? void 0 : options.en) || {})
        }
    };
    if (options) {
        var customLocales = Object.keys(options).filter(function (key) { return key !== 'en'; });
        customLocales.forEach(function (locale) {
            translationsJson[locale] = { translation: options[locale] };
        });
    }
    var languages = Object.keys(translationsJson);
    i18next_1["default"]
        .use(react_i18next_1.initReactI18next)
        .use(i18next_browser_languagedetector_1["default"])
        .init({
        resources: translationsJson,
        react: {
            useSuspense: true
        },
        fallbackLng: 'en',
        supportedLngs: languages,
        detection: {
            order: ['localStorage', 'navigator'],
            // needs to be different from default to prevent overwrite by @sovryn/react-wallet
            lookupLocalStorage: exports.languageLocalStorageKey,
            // don't cache automatically into localStorage only on manual language change
            caches: [],
            excludeCacheFor: ['cimode']
        }
    }, function (error) {
        if (error) {
            console.error(error);
        }
    });
}
exports["default"] = initialize;
function changeLanguage(lng) {
    i18next_1["default"].changeLanguage(lng);
}
exports.changeLanguage = changeLanguage;
